module.exports = __webpack_public_path__ + "static/media/MSPTB.38f1a3d1.pdf";